import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownloadStatusCompleted = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 25,
	fill: "none",
	viewBox: "0 0 25 25",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#4CAF50",
		d: "M9.877 16.455 4.75 11.33l1.069-1.07 4.058 4.058 8.957-8.958 1.07 1.07L9.877 16.455Zm-4.05 3.904v-1.5h13v1.5h-13Z"
	})
});
export { SvgDownloadStatusCompleted as ReactComponent };
